import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BugTwoToneSvg from "@ant-design/icons-svg/es/asn/BugTwoTone";
import AntdIcon from '../components/AntdIcon';
var BugTwoTone = function BugTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BugTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BugTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BugTwoTone';
}
export default RefIcon;